<template>
  <div>
    <overview />
    <life-design />
    <family />
    <finance />
    <career />
    <action />
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import LifeDesign from './LifeDesign.vue'
import Overview from './Overview.vue'
import Family from './Family.vue'
import Finance from './Finance.vue'
import Career from './Career.vue'
import Action from './Action.vue'
import { mapState } from 'vuex'
export default {
  components: { LifeDesign, Overview, Family, Finance, Career, Action },
  name: 'All',

  data() {
    return {
      overlay: true,
      compareAggregtion: {},
    }
  },
  async created() {},
  mounted() {
    setTimeout(() => {
      this.overlay = false
    }, 8000)
    setTimeout(window.print, 8000)
  },
  computed: {
    ...mapState(['classId']),
  },
  methods: {
    print() {
      window.print()
    },
  },
}
</script>

<style
  lang="scss"
  scoped></style>
